<template>
  <section id="contact" class="relative py-20">
    <!-- Background image -->
    <div class="absolute inset-0 z-0">
      <img
        src="/images/contact-bg.webp"
        alt="Background"
        class="w-full h-full object-cover object-bottom"
      />
      <div class="absolute inset-0 bg-black/50"></div>
    </div>

    <!-- Content -->
    <div class="relative z-10 container mx-auto px-4">
      <h2 class="text-3xl md:text-4xl font-bold text-center text-white mb-12">
        Pour nous contacter
      </h2>

      <form class="max-w-3xl mx-auto" @submit.prevent>
        <!-- Error message -->
        <div v-if="errorMessage" class="mb-4 p-3 bg-red-500/80 text-white rounded text-center">
          {{ errorMessage }}
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
          <!-- Name -->
          <div>
            <input
              v-model="form.name"
              type="text"
              placeholder="Nom / Name *"
              class="w-full px-4 py-3 bg-white/90 border-0 rounded focus:outline-none focus:ring-2 focus:ring-gascon-gold"
              required
            />
          </div>

          <!-- Establishment -->
          <div>
            <input
              v-model="form.establishment"
              type="text"
              placeholder="Établissement / Society"
              class="w-full px-4 py-3 bg-white/90 border-0 rounded focus:outline-none focus:ring-2 focus:ring-gascon-gold"
            />
          </div>

          <!-- Phone -->
          <div>
            <input
              v-model="form.phone"
              type="tel"
              placeholder="Téléphone / Phone number *"
              class="w-full px-4 py-3 bg-white/90 border-0 rounded focus:outline-none focus:ring-2 focus:ring-gascon-gold"
              required
            />
          </div>

          <!-- Email -->
          <div>
            <input
              v-model="form.email"
              type="email"
              placeholder="Email *"
              class="w-full px-4 py-3 bg-white/90 border-0 rounded focus:outline-none focus:ring-2 focus:ring-gascon-gold"
              required
            />
          </div>

          <!-- City -->
          <div>
            <input
              v-model="form.city"
              type="text"
              placeholder="Ville / City"
              class="w-full px-4 py-3 bg-white/90 border-0 rounded focus:outline-none focus:ring-2 focus:ring-gascon-gold"
            />
          </div>

          <!-- Availability -->
          <div>
            <input
              v-model="form.availability"
              type="text"
              placeholder="Disponibilité / Free Time"
              class="w-full px-4 py-3 bg-white/90 border-0 rounded focus:outline-none focus:ring-2 focus:ring-gascon-gold"
            />
          </div>
        </div>

        <!-- Buttons -->
        <div class="flex flex-col sm:flex-row justify-center gap-4">
          <button
            type="button"
            @click="downloadCatalogue"
            class="bg-gascon-gold text-gascon-blue px-8 py-3 font-semibold hover:opacity-90 hover:cursor-pointer transition-opacity rounded"
            :disabled="loading"
          >
            {{ loading ? 'Envoi en cours...' : 'Obtenir le catalogue !' }}
          </button>
          <button
            type="button"
            @click="openMailto"
            class="border-2 border-white text-white px-8 py-3 font-semibold hover:bg-white hover:text-gascon-blue hover:cursor-pointer transition-colors rounded"
          >
            Discuter !
          </button>
        </div>
      </form>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ContactSection',
  data() {
    return {
      form: {
        name: '',
        establishment: '',
        phone: '',
        email: '',
        city: '',
        availability: ''
      },
      loading: false,
      errorMessage: ''
    }
  },
  methods: {
    async downloadCatalogue() {
      if (!this.validateForm()) return

      this.loading = true

      try {
        // Send contact info to backend
        const response = await fetch('/api/catalogue_request', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content
          },
          body: JSON.stringify(this.form)
        })

        if (response.ok) {
          // Download the catalogue
          window.open('/catalogue.pdf', '_blank')
          this.resetForm()
        } else {
          this.errorMessage = 'Une erreur est survenue. Veuillez réessayer.'
        }
      } catch (error) {
        console.error('Catalogue request error:', error)
        this.errorMessage = 'Une erreur est survenue. Veuillez réessayer.'
      } finally {
        this.loading = false
      }
    },
    openMailto() {
      if (!this.validateForm()) return

      const subject = encodeURIComponent('Demande de contact - Comptoir Gascon')
      const body = encodeURIComponent(
        `Nom : ${this.form.name}\n` +
        `Établissement : ${this.form.establishment}\n` +
        `Téléphone : ${this.form.phone}\n` +
        `Email : ${this.form.email}\n` +
        `Ville : ${this.form.city}\n` +
        `Disponibilité : ${this.form.availability}\n\n` +
        `Message :\n`
      )
      window.location.href = `mailto:lepetitcomptoir@comptoirgascon.fr?subject=${subject}&body=${body}`
    },
    validateForm() {
      this.errorMessage = ''
      if (!this.form.name || !this.form.phone || !this.form.email) {
        this.errorMessage = 'Veuillez remplir les champs obligatoires (Nom, Téléphone, Email)'
        return false
      }
      return true
    },
    resetForm() {
      this.form = {
        name: '',
        establishment: '',
        phone: '',
        email: '',
        city: '',
        availability: ''
      }
    }
  }
}
</script>
